import {Fetch} from "./Fetch";

export class PaymentAPI {

    static SUBSCRIPTION_STATUS = {
        "ACTIVE": 0,
        "IN_COMPLETE": 1,
        "CANCELLED": 2,
        "REQUIRES_PAYMENT_METHOD": 3,
    };

    static async getPriceDetails(id){
       return Fetch("GET", `api/payment/price/${id}`)
    }

    static async getPaymentMethods(){
       return Fetch("GET", `api/payment/customer/payment_methods`)
    }

    static async updatePaymentMethods(payment_method_id, extraData){
       return Fetch("POST", `api/payment/customer/payment_methods`, {...extraData, payment_method_id, })
    }

    static async getSubscriptionDetails(){
       return Fetch("GET", `api/payment/subscription/`)
    }

    static async downgradeToFree(){
       return Fetch("PUT", `api/payment/subscription/downgrade/`)
    }

    static async getCreditsDetails(){
       return Fetch("GET", `api/payment/credits/remaining`)
    }

    static async applyCoupon(code, productId){
       return Fetch("GET", `api/payment/coupon/${code}/${productId}`)
    }

    static async cancelSubscription(){
       return Fetch("POST", `api/payment/cancel_subscription`)
    }

    static async listInvoices(){
       return Fetch("GET", `api/payment/list-invoices`)
    }
}
